<div class="flex flex-col h-screen w-screen">
  <app-header></app-header>
  <main class="flex-1 h-[calc(100vh-4rem)]">
    <router-outlet></router-outlet>
  </main>
</div>
